/**
 * SEO meta helper - 给 vue-meta 用的统一构造器，避免每个页面手写 og/twitter/canonical 重复字段。
 *
 * 用法（在 Vue 组件里）：
 *   import { buildMeta } from 'src/utils/seo'
 *   export default {
 *     metaInfo () {
 *       return buildMeta({
 *         title: 'Products',
 *         description: 'Choose hardcover or softcover...',
 *         path: '/products'
 *       })
 *     }
 *   }
 *
 * 私区组件不要调 buildMeta，由 App.vue 顶层根据路径自动加 noindex。
 */

const SITE = {
  baseUrl: 'https://ipastbook.com/2.0',
  defaultTitle: 'iPastBook - Turn Your Social Media Into a Beautiful Book',
  defaultDescription: 'Turn your Facebook, Instagram and X posts into a beautiful printed book. Auto-formatted, easy to customize, delivered worldwide.',
  defaultImage: 'https://static.ipastbook.com/assets/images/hero-1.jpg'
}

export function buildMeta ({ title, description, path = '', image, type = 'website', noindex = false } = {}) {
  const fullTitle = title ? `${title} - iPastBook` : SITE.defaultTitle
  const desc = description || SITE.defaultDescription
  const url = SITE.baseUrl + (path || '/')
  const img = image || SITE.defaultImage
  const robots = noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'

  return {
    title: fullTitle,
    // 别让 vue-meta 自动拼 titleTemplate；我们已经在 title 里 append 品牌名
    titleTemplate: null,
    meta: [
      { vmid: 'description', name: 'description', content: desc },
      { vmid: 'og:title', property: 'og:title', content: fullTitle },
      { vmid: 'og:description', property: 'og:description', content: desc },
      { vmid: 'og:url', property: 'og:url', content: url },
      { vmid: 'og:image', property: 'og:image', content: img },
      { vmid: 'og:type', property: 'og:type', content: type },
      { vmid: 'twitter:title', name: 'twitter:title', content: fullTitle },
      { vmid: 'twitter:description', name: 'twitter:description', content: desc },
      { vmid: 'twitter:image', name: 'twitter:image', content: img },
      // 默认 indexable；传 noindex:true 时下架（已废弃 / 老页面用）
      { vmid: 'robots', name: 'robots', content: robots }
    ],
    link: [
      { vmid: 'canonical', rel: 'canonical', href: url }
    ]
  }
}

export const SEO_SITE = SITE
